import { UnderstandUserRolesButton } from '@modules/users/components/UnderstandUserRolesButton';
import { UsersTable } from '@modules/users/components/UsersTable';
import { WorkspaceSettingsItem } from '@modules/workspaceSettings/components/WorkspaceSettingsItem';
import { SupervisorAccountRounded } from '@mui/icons-material';

export const Users = () => {
  return (
    <WorkspaceSettingsItem
      icon={<SupervisorAccountRounded sx={{ color: 'text.secondary' }} />}
      title="Users"
      titleAction={<UnderstandUserRolesButton />}
    >
      <UsersTable />
    </WorkspaceSettingsItem>
  );
};
